
export class command {

    constructor() {

    }

    public execute() {
        ;
    }
}
